import { useEffect as e } from "/home/runner/work/oko-web/oko-web/node_modules/react/index.js";
//#region src/lib/hooks/useDebouncedEffect.ts
function t(t, n, r) {
	e(() => {
		let e = setTimeout(() => {
			t();
		}, n);
		return () => clearTimeout(e);
	}, [...r || [], n]);
}
//#endregion
export { t as useDebouncedEffect };
